import axios from 'axios';
import { toast } from 'react-toastify';

const env = (typeof globalThis !== 'undefined' && (globalThis as any).__APP_ENV__) || {};
const baseURL = (env.apiUrl as string) ?? '/api';
const tokenKey = (env.tokenKey as string) ?? 'authToken';

export const apiClient = axios.create({ baseURL });

apiClient.interceptors.request.use((config) => {
  if (typeof window !== 'undefined') {
    const token = window.localStorage.getItem(tokenKey);
    if (token) {
      if (config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      toast.error('Sesión expirada, inicia sesión nuevamente.');
    }
    return Promise.reject(error);
  },
);

export default apiClient;
